const { formatText } = require('core/i18n').i18n;

const TAXINGREASON  = () => {
   return({'R': formatText('taxingReason-residence').toUpperCase(),
    'U': formatText('taxingReason-citizenship').toUpperCase(),
    'X': formatText('taxingReason-both').toUpperCase()
    });
}

module.exports = TAXINGREASON;
